import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useExpertContext } from '../context/ExpertContext';

const { FiMapPin, FiUser, FiChevronRight, FiStar } = FiIcons;

const ExpertList = ({ experts, onExpertSelect }) => {
  const { getExpertRating } = useExpertContext();
  const approvedExperts = experts.filter(expert => expert.status === 'approved');

  if (approvedExperts.length === 0) {
    return (
      <div className="expert-card h-[500px] flex items-center justify-center">
        <div className="text-center text-gray-500">
          <SafeIcon icon={FiUser} className="text-4xl mb-3 mx-auto" />
          <p className="font-bold">No experts found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="expert-card h-[600px] overflow-hidden flex flex-col">
      <h3 className="text-xl font-black text-slate-900 mb-6 flex items-center justify-between">
        Available Experts
        <span className="bg-slate-100 text-slate-500 text-xs px-2.5 py-1 rounded-full">{approvedExperts.length}</span>
      </h3>
      <div className="flex-1 overflow-y-auto space-y-3 pr-2 custom-scrollbar">
        {approvedExperts.map((expert, index) => {
          const rating = getExpertRating(expert.id);
          return (
            <motion.div
              key={expert.id}
              initial={{ x: 20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: index * 0.05 }}
              className="bg-white border border-slate-100 rounded-2xl p-4 hover:border-green-300 hover:shadow-lg hover:shadow-green-500/5 transition-all duration-300 cursor-pointer group"
              onClick={() => onExpertSelect(expert)}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h4 className="font-black text-slate-900 group-hover:text-green-600 transition-colors">
                      {expert.full_name}
                    </h4>
                    {rating.count > 0 && (
                      <div className="flex items-center gap-0.5 bg-amber-50 px-1.5 py-0.5 rounded-md">
                        <SafeIcon icon={FiStar} className="text-[10px] text-amber-500 fill-amber-500" />
                        <span className="text-[10px] font-black text-amber-700">{rating.avg}</span>
                      </div>
                    )}
                  </div>
                  <div className="flex items-center space-x-2 mt-1.5 text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                    <SafeIcon icon={FiMapPin} className="text-green-500" />
                    <span>{expert.city}, {expert.governorate}</span>
                  </div>
                  <div className="mt-3 flex flex-wrap gap-1">
                    {expert.support_topics?.slice(0, 2).map((topic, i) => (
                      <span key={i} className="px-2 py-0.5 bg-slate-50 text-slate-500 rounded-md text-[9px] font-black border border-slate-100 uppercase">
                        {topic}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="w-8 h-8 rounded-xl bg-slate-50 flex items-center justify-center text-slate-300 group-hover:bg-green-600 group-hover:text-white transition-all">
                  <SafeIcon icon={FiChevronRight} />
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default ExpertList;